fragment ChatbotReportAiMetricsFragment on ChatbotReportAIMetrics {
    summary {
        performance
        activity
        impact
    }
    sentimentBreakdown {
        goodPercent
        badPercent
        neutralPercent
        goodSampleThreadIds
        badSampleThreadIds
        neutralSampleThreadIds
    }
    askedForHumanPercent
    commonTopics {
        topic
        threadIds
        threadCount
    }
    frustrationTopics {
        topic
        threadIds
        threadCount
    }
    knowledgeGaps {
        question
        threadIds
        threadCount
    }
    oddballThreads {
        topic
        description
        threadIds
        threadCount
    }
}
